const getters = {
    token: state => state.login.token,
    includePageNames:state => state.user.includePageNames//页面缓存
   
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js